<template>
  <div id="app">
    <router-view v-if="$route.path.indexOf('Report/ReportsViewList') != -1" :key="$route.path + $route.query.t" />
    <router-view v-else />
  </div>
</template>

<script>
export default {
  name: 'App',
  created(){
    window._AMapSecurityConfig = {
      securityJsCode: '95459f00ae6bd07d36ce9b72c5e1df2a', // 高德安全密钥
    }
  }
}
</script>

<style>
body {
  padding: 0;
  margin: 0;
  height: 100%;
  min-height: 100%;
  background-color: var(--layout-canvas-bg, #f0f2f5);
  background-image: var(--layout-canvas-gradient);
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
  background-size: cover;
}
#app {
  /* 全局字体：优先使用思源黑体（Source Han Sans SC），再做中英兜底 */
  font-family: "Source Han Sans SC", "思源黑体", "Source Han Sans", "Noto Sans SC", "PingFang SC", "Microsoft YaHei", "微软雅黑", "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #484a4d;
  height: 100%;
  /* background: url('./assets/images/previewFile.jpg') no-repeat center center;
  background-size: cover;
  background-position: center; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue